import React from 'react';
import styled from '@emotion/styled';

type Props = {
  message: string;
  srID: string;
};

const AccessibilityTitle = styled.span({
  position: 'absolute',
  top: '0',
  width: '0',
  height: '0',
  overflow: 'hidden',
});

export const AccessibilityText: React.FC<Props> = ({ message, srID }) => {
  return <AccessibilityTitle id={srID}>{message}</AccessibilityTitle>;
};
